import React, { ChangeEvent, Component, useContext, useState } from "react";
import "./QboPushCatalogItemsModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import IQBOPushCatalogItemsDTO from "../../../../models/DTO/IQBOPushCatalogItemsDTO";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";

type Props = {
    closeModalFn: () => void;
    startPushFn: (payload: IQBOPushCatalogItemsDTO) => void;
};

interface IFieldsAvailable {
    sku: boolean;
    name: boolean;
    taxable: boolean;
    description: boolean;
    inventory: boolean;
    active: boolean;
}

export const QboPushCatalogItemsModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [onlyPushUnconnectedItems, setOnlyPushUnconnectedItems] = useState<boolean>(false);
    const [onlyPushConnectedItems, setOnlyPushConnectedItems] = useState<boolean>(false);
    const [onlySpecificFields, setOnlySpecificFields] = useState<boolean>(false);
    const [specificFields, setSpecificFields] = useState<IFieldsAvailable>({
        sku: false,
        name: false,
        taxable: false,
        description: false,
        inventory: false,
        active: false,
    });

    const closeModal = () => {
        props.closeModalFn();
    };

    const startPush = () => {
        const payload: IQBOPushCatalogItemsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            catalogGuid: "catalogGuid",
            onlyUnconnectedItems: onlyPushUnconnectedItems,
            onlyConnectedItems: onlyPushConnectedItems,
            specificFields: onlySpecificFields,
            fields: {
                ...specificFields,
            },
        };

        props.startPushFn(payload);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        switch (name) {
            case "only_connected_items":
                setOnlyPushConnectedItems(value);
                break;
            case "only_unconnected_items":
                setOnlyPushUnconnectedItems(value);
                break;

            case "specific_fields":
                setOnlySpecificFields(value);
                break;
        }
    };

    const handleSpecificFields = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const initialObj = {
            ...specificFields,
        };

        switch (name) {
            case "sku":
                initialObj.sku = value;
                break;

            case "name":
                initialObj.name = value;
                break;

            case "description":
                initialObj.description = value;
                break;

            case "taxable":
                initialObj.taxable = value;
                break;

            case "inventory":
                initialObj.inventory = value;
                break;

            case "active":
                initialObj.active = value;
                break;
        }

        setSpecificFields(initialObj);
    };

    return (
        <div className={"QboPushCatalogItemsModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"push_catalog_items"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwCheckbox
                        name={"only_unconnected_items"}
                        label={"only_unconnected_items"}
                        truthyVal={true}
                        falsyVal={false}
                        fn={handleChange}
                        checked={onlyPushUnconnectedItems}
                        disabled={onlyPushConnectedItems}
                    />
                </div>

                <div>
                    <OwCheckbox
                        name={"only_connected_items"}
                        label={"only_connected_items"}
                        truthyVal={true}
                        falsyVal={false}
                        fn={handleChange}
                        checked={onlyPushConnectedItems}
                        disabled={onlyPushUnconnectedItems}
                    />
                </div>

                <div className={"mt-4"}>
                    <OwCheckbox
                        name={"specific_fields"}
                        label={"specific_fields"}
                        truthyVal={true}
                        falsyVal={false}
                        fn={handleChange}
                        checked={onlySpecificFields}
                    />
                </div>

                {onlySpecificFields ? (
                    <div className="mt-2">
                        <div>
                            <OwCheckbox
                                label={"sku"}
                                name={"sku"}
                                checked={specificFields.sku}
                                fn={handleSpecificFields}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>

                        <div>
                            <OwCheckbox
                                label={"name"}
                                name={"name"}
                                checked={specificFields.name}
                                fn={handleSpecificFields}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>

                        <div>
                            <OwCheckbox
                                label={"description"}
                                name={"description"}
                                checked={specificFields.description}
                                fn={handleSpecificFields}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>

                        <div>
                            <OwCheckbox
                                label={"inventory"}
                                name={"inventory"}
                                checked={specificFields.inventory}
                                fn={handleSpecificFields}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>

                        <div>
                            <OwCheckbox
                                label={"taxable"}
                                name={"taxable"}
                                checked={specificFields.taxable}
                                fn={handleSpecificFields}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>

                        <div>
                            <OwCheckbox
                                label={"active"}
                                name={"active"}
                                checked={specificFields.active}
                                fn={handleSpecificFields}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                    </div>
                ) : null}

                <div className={"mt-4"}>
                    <OwButton title={"start"} fn={startPush} />
                </div>
            </div>
        </div>
    );
};
